import React from 'react';
import { PHONE, WHATSAPP_URL } from '../data/content';
import './Footer.css';

export default function Footer() {
  return (
    <footer>
      <div className="footer-grid">
        {/* Brand */}
        <div>
          <div className="footer-brand-name">SWATHI'S</div>
          <div className="footer-tagline">We BetterR Wellness · Supporting your wellness naturally</div>
          <p className="footer-desc">
            A passionate wellness brand dedicated to bringing the power of traditional Indian
            herbs to modern families. Every pack is made with care and commitment to your health.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <div className="footer-col-title">Quick Links</div>
          <ul className="footer-links">
            <li><a href="#ingredients">Ingredients</a></li>
            <li><a href="#benefits">Benefits</a></li>
            <li><a href="#how-to-use">How to Use</a></li>
            <li><a href="#testimonials">Reviews</a></li>
            <li><a href="#order">Order Now</a></li>
          </ul>
        </div>

        {/* Product */}
        <div>
          <div className="footer-col-title">Product</div>
          <ul className="footer-links">
            <li><a href="#ingredients">Diabetic Wellness Powder</a></li>
            <li><a href="#ingredients">Ingredients Guide</a></li>
            <li><a href="#order">FAQ</a></li>
            <li><a href="#order">Shipping Policy</a></li>
            <li><a href="#order">Return Policy</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <div className="footer-col-title">Contact Us</div>
          <p><span>📱</span> {PHONE}</p>
          <p><span>💬</span> WhatsApp orders welcome</p>
          <p><span>📍</span> Made &amp; delivered from India</p>
          <p><span>🕐</span> Mon–Sat, 9 AM – 7 PM</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Swathi's We BetterR Wellness. All rights reserved.</p>
        <div className="india-badge">🇮🇳 Proudly Made in India</div>
      </div>

      <p className="footer-disclaimer">
        Disclaimer: This product is a herbal wellness supplement. Not intended to diagnose,
        treat, cure or prevent any disease. Consult your healthcare professional before use
        if you are on medication.
      </p>
    </footer>
  );
}
